export default function initTimelineCarousel() {
  const wrappers = document.querySelectorAll(".timeline-carousel");

  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    const list = wrapper.querySelector(".timeline-list");
    const progressBar = wrapper.querySelector(".carousel-progress-bar");
    const nextButton = wrapper.querySelector(".carousel-button-next");
    const prevButton = wrapper.querySelector(".carousel-button-prev");
    const carouselControls = wrapper.querySelector(".carousel-controls");

    if (!list) return;

    const items = list.querySelectorAll(".timeline-item");
    if (!items.length) return;

    // Set --cols dynamically based on number of items
    list.style.setProperty("--cols", items.length);

    // Track logical scroll index for reliable button states
    let currentIndex = 0;

    function getItemWidth() {
      const gap = parseInt(getComputedStyle(list).gap) || 0;
      return items[0].offsetWidth + gap;
    }

    function getMaxIndex() {
      const itemWidth = getItemWidth();
      if (itemWidth <= 0) return 0;
      const maxScroll = list.scrollWidth - list.clientWidth;
      return Math.max(0, Math.ceil(maxScroll / itemWidth));
    }

    function syncIndexFromScroll() {
      const itemWidth = getItemWidth();
      if (itemWidth <= 0) return;
      currentIndex = Math.round(list.scrollLeft / itemWidth);
    }

    function updateProgressBar() {
      if (!progressBar) return;
      const scrollLeft = list.scrollLeft;
      const maxScroll = list.scrollWidth - list.clientWidth;
      const progress =
        maxScroll > 0
          ? ((scrollLeft + list.clientWidth) / list.scrollWidth) * 100
          : 100;
      progressBar.style.width = `${Math.min(progress, 100)}%`;
    }

    function updateButtonStates() {
      const maxIndex = getMaxIndex();

      if (prevButton) {
        prevButton.disabled = currentIndex <= 0;
      }
      if (nextButton) {
        nextButton.disabled = currentIndex >= maxIndex;
      }
    }

    function updateControlsVisibility() {
      if (!carouselControls) return;
      const maxScroll = list.scrollWidth - list.clientWidth;
      if (maxScroll <= 0) {
        carouselControls.style.display = "none";
      } else {
        carouselControls.style.display = "";
      }
    }

    if (nextButton) {
      nextButton.addEventListener("click", () => {
        const maxIndex = getMaxIndex();
        if (currentIndex >= maxIndex) return;
        currentIndex++;
        const targetScroll = currentIndex * getItemWidth();
        list.scrollTo({ left: targetScroll, behavior: "smooth" });
        updateButtonStates();
      });
    }

    if (prevButton) {
      prevButton.addEventListener("click", () => {
        if (currentIndex <= 0) return;
        currentIndex--;
        const targetScroll = currentIndex * getItemWidth();
        list.scrollTo({ left: targetScroll, behavior: "smooth" });
        updateButtonStates();
      });
    }

    // Sync index when user manually scrolls/swipes
    list.addEventListener("scrollend", () => {
      syncIndexFromScroll();
      updateProgressBar();
      updateButtonStates();
    });

    list.addEventListener("scroll", () => {
      updateProgressBar();
    });

    // Handle resize to update controls visibility
    window.addEventListener("resize", () => {
      updateControlsVisibility();
      syncIndexFromScroll();
      updateProgressBar();
      updateButtonStates();
    });

    function refreshAll() {
      updateControlsVisibility();
      syncIndexFromScroll();
      updateProgressBar();
      updateButtonStates();
    }

    // Initial state - wait for layout to be ready
    requestAnimationFrame(refreshAll);

    // If inside a hidden panel, recalculate when it becomes visible
    // Safari doesn't recalculate grid columns using 100% when parent was hidden
    const panel = wrapper.closest(".panel");
    if (panel && !panel.classList.contains("active")) {
      const observer = new MutationObserver(() => {
        if (panel.classList.contains("active")) {
          // Force Safari to recalculate grid layout
          list.style.display = "none";
          void list.offsetHeight;
          list.style.display = "";
          requestAnimationFrame(refreshAll);
          observer.disconnect();
        }
      });
      observer.observe(panel, { attributes: true, attributeFilter: ["class"] });
    }
  });
}
